import {
  CloseSharp,
  DeleteSharp,
  MoneyOffSharp,
  PreviewOutlined
} from "@mui/icons-material";
import {
  Button,
  Grid,
  IconButton,
  Stack
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../axiosInstances";
import { ShoppingCartContext } from "./Context/ShoppingCartContext";
import CheckPreview from "./Reports/CheckPreview";
import InvoicePreview from "./Reports/InvoicePreview";

export default function PaymentsModelHistory(props) {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);
  const { globalToken } = useContext(ShoppingCartContext);
  var fileObj = [];
  var fileArray = [];
  const [id, setId] = useState(props.data.Id);
  const [paidBy, setPaidBy] = useState(props.data.PaidBy);
  const [paidByName, setPaidByName] = useState(props.data.PaidByName);

  const [paidTo, setPaidTo] = useState(props.data.PaidTo);
  const [paidToName, setPaidToName] = useState(props.data.PaidToName);
  const [paidDate, setPaidDate] = useState(props.data.PaidDate);
  const [orderNo, setOrderNo] = useState(props.data.OrderNo);
  const [amount, setAmount] = useState(
    props.data?.Amount ? props.data?.Amount?.toString().replace(",", "") : 0
  );
  const [depositSlip, setDepositSlip] = useState(
    props.data?.DepositSlip?.split(",")
  );

  const [bankList] = useState(props.BankList);
  const [bank, setBank] = useState(props.data.Bank);
  const [remark, setRemark] = useState(props.data.Remark);
  const [paymentType, setPaymentType] = useState(props.data.Type);

  function uploadMultipleFiles(e) {
    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      fileArray.push(URL.createObjectURL(fileObj[0][i]));
    }
    setDepositSlip(fileArray);
  }
  const handleSubmit = (stat) => {
    if (paidTo === null || paidTo === 0) {
      alert("Paid to field is required");
      return;
    }
    if (amount === null || amount <= 0) {
      alert("Amount field is required");
      return;
    }
    if (paymentType === "Deposit") {
      if (
        depositSlip === undefined ||
        depositSlip === null ||
        depositSlip.length <= 0
      ) {
        alert("Attachment field is required");
        return;
      }
    } //check wallet balance here in else when wallet and process telbir here too
    if (window.confirm("Are you sure you want to pay?")) {
      try {
        var fd = new FormData();
        fd.append("Id", id);
        fd.append("PaidBy", paidBy);
        fd.append("PaidTo", paidTo);
        fd.append("OrderNo", orderNo);
        fd.append("Amount", amount);
        fd.append("PaidDate", paidDate);

        Array.from(document.getElementById("DepositSlip").files).map((file) => {
          fd.append("DepositSlip", file);
        });
        fd.append("Type", paymentType);
        fd.append("Status", stat);
        fd.append("Remark", remark);

        axios.post("/payments", fd, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: globalToken,
          },
        });
      } catch (err) {
      } finally {
        props.data && props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        axios.delete("/payments?Id=" + id, {
          headers: {
            token: globalToken,
          },
        })

      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate)
        setOpen(false);
      }
    }
  };

  return (
    <div width="500">
      <label onClick={() => setOpen(true)}>{props.icon}</label>
      <Dialog
        maxWidth="md"
        /*      PaperProps={{
           sx: {
             height: '80vh',   // 80% of viewport height
             maxHeight: '90vh',
           },
         }} */
        PaperProps={{
          style: {
            borderRadius: 24,
            backgroundColor: '#fffcf9', // Warm off-white
            boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
          }
        }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          bgcolor={theme.palette.primary.main}
          color={theme.palette.primary.contrastText}
        >
          <Stack direction='row' style={{ flex: 1 }}>
            <div style={{ flex: 1 }}>
              {props.Type ? props.Type + " Payment" : " Payment"}{" "}
            </div>
            <IconButton style={{ backgroundColor: theme.palette.primary.light }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <hr></hr>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {"Paid By: " + paidByName}
              </Grid>

              <Grid item xs={12} md={6}>
                {"Paid To: " + paidToName}
              </Grid>
              <Grid item xs={12} md={6}>
                {"Paid Date: " + paidDate}
              </Grid>
              <Grid item xs={12} md={6}>
                {"Paid Amount: "}
                {(parseFloat(amount)?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                  minFractionDigits: 2,
                }))}
              </Grid>
              <Grid item xs={12} md={6}>
                {"Document No: " + props.data?.Id
                }
              </Grid>
              <Grid item xs={12} md={6}>
                {"Order No: " + props.data?.OrderNo
                }
              </Grid>
              <Grid item xs={12} md={6}>
                {"Payment Type: " + paymentType}
              </Grid>
              <Grid item xs={12} md={6}>
                {"Bank: " + (bank ? bank : "")}
              </Grid>
              <Grid item xs={12} md={6}>
                {"Remark: " + (remark ? remark : "")}
              </Grid>
              {props.data && props.data?.DepositSlip?.split(",").length > 0 && (
                <Grid
                  item
                  xs={12}
                  style={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    cursor: "pointer",
                  }}
                >
                  Attachment
                  <div className="form-group multi-preview">
                    {(depositSlip || []).map((address, index) => (
                      <img
                        key={index}
                        src={address}
                        alt="..."
                        style={{ width: "100%", height: "100" }}
                      />
                    ))}
                  </div>
                </Grid>
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            flexWrap: 'wrap',
          }}
        >
          <Button variant="standard"
            sx={{
              borderRadius: 5,
              fontSize: "10px",
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.light }
            }}
            endIcon={<MoneyOffSharp />}>
            <CheckPreview
              icon={<div style={{ color: theme.palette.primary.contrastText }}>Cheque</div>}
              data={props.data}
              Type="Payment"
              DocumentType={props.Type}
            />
          </Button>
          |
          <Button variant="standard"
            sx={{
              borderRadius: 5,
              fontSize: "10px",
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.light }
            }}
            endIcon={<PreviewOutlined />}>
            <InvoicePreview
              icon={<div style={{ color: theme.palette.primary.contrastText }}>Preview</div>}

              data={props.data}
              Type="Payment"
              DocumentType={props.Type}
            />
          </Button>
          |
          <Button
            variant="standard"
            sx={{
              borderRadius: 5,
              fontSize: "10px",
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.light }
            }}
            autoFocus
            onClick={handleDelete}
            endIcon={<DeleteSharp />}
          >
            Delete
          </Button>
          |
          <Button
            variant="standard"
            sx={{
              borderRadius: 5,
              fontSize: "10px",
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.light }
            }}
            onClick={() => setOpen(false)}
            autoFocus
            endIcon={<CloseSharp />}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
